module.exports = __webpack_public_path__ + "img/DE.fb8b3980.svg";